"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var injectScriptToElement = function (src, element) {
    return new Promise(function (resolve, reject) {
        var scriptElement = document.createElement("script");
        scriptElement.onload = function () { return resolve(); };
        scriptElement.onerror = function () { return reject(); };
        scriptElement.async = false;
        scriptElement.src = src;
        element.appendChild(scriptElement);
    });
};
exports.default = injectScriptToElement;
